import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  width: 100vw;
  min-height: 100vh;
  overflow-y: auto;
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 24px 7vw;
  border-bottom: 1px solid #e8eaed;
  background: #ffffff;

  @media ${theme.devices.tablet} {
    flex-direction: column;
    padding: 16px 20px;
    gap: 16px;
  }
`;

export const LogoImg = styled.img`
  height: 56px;
  cursor: pointer;

  @media ${theme.devices.tablet} {
    height: 48px;
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${theme.devices.tablet} {
    padding: 20px 16px;
    gap: 20px;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h1`
  font-family: "Roboto", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: #202124;
  margin: 0;

  @media ${theme.devices.tablet} {
    font-size: 24px;
  }
`;

export const Subtitle = styled.p`
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #5f6368;
  margin: 0;
`;

export const FiltersSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 16px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e8eaed;
  flex-wrap: wrap;

  @media ${theme.devices.tablet} {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 200px;

  @media ${theme.devices.tablet} {
    min-width: 100%;
  }
`;

export const FilterLabel = styled.label`
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #5f6368;
`;

export const DateInputsRow = styled.div`
  display: flex;
  gap: 12px;

  @media ${theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const DateInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`;

export const DateLabel = styled.span`
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  color: #5f6368;
`;

export const SearchInput = styled.input`
  padding: 10px 16px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #202124;
  background: #ffffff;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #4285f4;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
  }

  &::placeholder {
    color: #80868b;
  }
`;

export const DateInput = styled.input`
  padding: 10px 16px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #202124;
  background: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #4285f4;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
  }
`;

export const UpdateButton = styled.button`
  padding: 10px 28px;
  background: #4285f4;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: fit-content;

  &:hover {
    background: #3367d6;
    box-shadow: 0 2px 8px rgba(66, 133, 244, 0.3);
  }

  &:active {
    transform: scale(0.98);
  }

  @media ${theme.devices.tablet} {
    width: 100%;
  }
`;

export const ActionsBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  @media ${theme.devices.tablet} {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SelectionInfo = styled.div`
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #5f6368;
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    color: #4285f4;
    font-weight: 500;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;

  @media ${theme.devices.tablet} {
    width: 100%;
    
    button {
      flex: 1;
    }
  }
`;

export const SecondaryButton = styled.button`
  padding: 8px 20px;
  background: #ffffff;
  color: #5f6368;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    border-color: #bdc1c6;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const TableContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead`
  background: #f8f9fa;
  border-bottom: 2px solid #e8eaed;
`;

export const TableHeaderRow = styled.tr``;

export const TableHeaderCell = styled.th<{ $sortable?: boolean }>`
  padding: 16px 20px;
  text-align: left;
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #5f6368;
  cursor: ${props => props.$sortable ? 'pointer' : 'default'};
  user-select: none;
  white-space: nowrap;
  transition: background 0.2s ease;

  &:hover {
    background: ${props => props.$sortable ? '#f1f3f4' : 'transparent'};
  }

  &:first-child {
    width: 40px;
  }

  @media ${theme.devices.tablet} {
    padding: 12px 16px;
    font-size: 12px;
  }
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr<{ $selected?: boolean }>`
  border-bottom: 1px solid #e8eaed;
  background: ${props => props.$selected ? '#e8f0fe' : '#ffffff'};
  transition: background 0.15s ease;

  &:hover {
    background: ${props => props.$selected ? '#e8f0fe' : '#f8f9fa'};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TableCell = styled.td`
  padding: 16px 20px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #202124;

  @media ${theme.devices.tablet} {
    padding: 12px 16px;
    font-size: 13px;
  }
`;

export const CheckboxCell = styled(TableCell)`
  width: 40px;
  padding: 16px 12px;
`;

export const KeywordCell = styled(TableCell)`
  font-weight: 500;
  color: #1967d2;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const MonthCell = styled(TableCell)`
  text-align: center;
  min-width: 80px;
`;

export const TrendBadge = styled.span<{ $trend: 'up' | 'down' | 'neutral' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  min-width: 45px;
  
  ${props => {
    switch (props.$trend) {
      case 'up':
        return `
          background: #e6f4ea;
          color: #1e8e3e;
        `;
      case 'down':
        return `
          background: #fce8e6;
          color: #d93025;
        `;
      default:
        return `
          background: #f1f3f4;
          color: #5f6368;
        `;
    }
  }}
`;

export const TotalCell = styled(TableCell)`
  font-weight: 600;
  color: #202124;
  text-align: center;
`;

export const EmptyState = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: #5f6368;
  font-family: "Roboto", sans-serif;

  .icon {
    font-size: 64px;
    color: #dadce0;
    margin-bottom: 16px;
  }

  h3 {
    font-size: 18px;
    font-weight: 500;
    color: #202124;
    margin: 0 0 8px 0;
  }

  p {
    font-size: 14px;
    color: #5f6368;
    margin: 0;
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid #e8eaed;
  background: #ffffff;

  @media ${theme.devices.tablet} {
    flex-direction: column;
    gap: 12px;
  }
`;

export const PaginationInfo = styled.span`
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  color: #5f6368;
`;

export const PaginationButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const PaginationButton = styled.button<{ $active?: boolean }>`
  padding: 6px 12px;
  background: ${props => props.$active ? '#4285f4' : '#ffffff'};
  color: ${props => props.$active ? '#ffffff' : '#5f6368'};
  border: 1px solid ${props => props.$active ? '#4285f4' : '#dadce0'};
  border-radius: 6px;
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 36px;

  &:hover:not(:disabled) {
    background: ${props => props.$active ? '#3367d6' : '#f8f9fa'};
    border-color: ${props => props.$active ? '#3367d6' : '#bdc1c6'};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #4285f4;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  color: #5f6368;
`;
